import { render, staticRenderFns } from "./UIInputTextArea.vue?vue&type=template&id=9aa23ccc&"
import script from "./UIInputTextArea.vue?vue&type=script&lang=js&"
export * from "./UIInputTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports